import { getCookie } from '@vfde-sails/utils';
import { StateProps } from '../interface';
import { initialState } from '../reducer';
import { ADDRESS_COOKIE_NAME } from '../constant';

const getAddressFromCookie = (draftState: StateProps) => {
    const addressCookie = getCookie(ADDRESS_COOKIE_NAME);

    if (addressCookie) {
        draftState.address = JSON.parse(atob(decodeURIComponent(addressCookie)));
    }

    return draftState;
};

export const loadInitialAppState = (): Partial<StateProps> => {
    try {
        // we need a deep copy of initialState because 'immer' makes it read-only
        let draftState: StateProps = JSON.parse(JSON.stringify(initialState));

        return getAddressFromCookie(draftState);
    } catch (_) {
        return initialState;
    }
};
